import type { TemplateOnlyComponent } from '@ember/component/template-only';

export enum SidebarPosition {
  Left = 'left',
  Right = 'right',
}

const DEFAULT_POSITION = SidebarPosition.Right;

function sidebarClass(position: SidebarPosition = DEFAULT_POSITION) {
  return position === SidebarPosition.Left
    ? 'll-sidebar-left'
    : 'll-sidebar-right';
}

export const Sidebar: TemplateOnlyComponent<{
  Args: {
    position?: SidebarPosition;
    disableScaling?: boolean;
  };
  Element: HTMLDivElement;
  Blocks: { content: []; sidebar: [] };
}> = <template>
  <div class="ll-sidebar {{sidebarClass @position}}" ...attributes>
    <div class="ll-sidebar-panel bg-primary-subtle">
      <div class="">
        {{yield to="sidebar"}}
      </div>
    </div>

    <div class="ll-sidebar-content">
      <div class="sticky-top shadow">
        <div class={{unless @disableScaling "ll-sidebar-content-transform"}}>
          <div class="ll-sidebar-content-width">
            {{yield to="content"}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>;
